var exports = {
  "Q": "EditGuildStickerModal.module__content___b2NSd0",
};

module.exports = exports;
